import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const SUPPORTED_LANGUAGES = ['en', 'de', 'es', 'fi', 'fr', 'it', 'nl', 'pl', 'pt', 'sv', 'tr'];

@Injectable({
	providedIn: 'root',
})
export class AppLanguageService {
	private translate: TranslateService = inject(TranslateService);

	fnInit() {
		this.translate.setDefaultLang('en');
		this.translate.addLangs(SUPPORTED_LANGUAGES);

		const browserLang = this.detectBrowserLanguage();
		this.translate.use(browserLang);
	}

	private detectBrowserLanguage(): string {
		const languages = navigator.languages ?? [navigator.language];

		for (const lang of languages) {
			const base = lang.split('-')[0].toLowerCase();
			if (SUPPORTED_LANGUAGES.includes(base)) {
				return base;
			}
		}

		return 'en';
	}
}
